import React from "react";
import { PiCheckCircleFill, PiXCircleFill } from "react-icons/pi";
import close from "../../assets/images/icons/close-01.svg";

const PaymentStatusModal = ({
  status,
  convergeId,
  onClose,
  buttonName = "",
  onNavigate,
  type,
  screen,
  payment = false,
}) => {
  let token = localStorage.getItem("GSTB_token");
  if (!status) return null;

  const isSuccess = status === "success";

  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
      style={{ zIndex: 1050, backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div
        className="bg-white p-5 rounded-4 shadow text-center position-relative"
        style={{ maxWidth: "600px", width: "90%" }}
      >
        <div
          className="payment-close-btn"
          onClick={() => onClose()}
          aria-label="Close"
        >
          <img
            src={close}
            alt="Close"
            style={{ height: "24px", width: "24px", cursor: "pointer" }}
          />
        </div>
        {/* ICON */}
        <div className="mb-3">
          {isSuccess ? (
            <PiCheckCircleFill className="text-success" size={60} />
          ) : (
            <PiXCircleFill className="text-danger" size={60} />
          )}
        </div>

        {/* TITLE */}
        <h3
          className={`fw-bold mb-2 ${
            isSuccess ? "text-success" : "text-danger"
          }`}
        >
          {isSuccess && !payment
            ? "Payment Successful!"
            : isSuccess && payment
            ? "RSVP Submitted!"
            : "Payment Failed"}
        </h3>

        <p className="text-muted mb-4">
          {isSuccess
            ? type === "donate"
              ? "Thank you for Supporting Gujarati Samaj of Tampa Bay Inc!"
              : type === "event"
              ? "Thank You! Your RSVP has been successfully submitted."
              : "Thank you! Your transaction has been completed successfully."
            : "Something went wrong with your transaction. Please try again."}
        </p>

        {isSuccess && screen === "rsvp" && (
          <div
            className="mb-4 text-center mx-auto"
            style={{ maxWidth: "520px" }}
          >
            <p className="mb-1">
              Your ticket has been emailed to you. Please check your inbox and
              spam folder.
            </p>
          </div>
        )}

        {isSuccess && (screen === "purchase" || screen === "reserve") && (
          <div
            className="mb-4 text-center mx-auto"
            style={{ maxWidth: "520px" }}
          >
            <p className="mb-1">
              Your ticket has been emailed to you. Please check your inbox and
              spam folder.
            </p>
          </div>
        )}

        {isSuccess && type === "donate" && (
          <div
            className="mb-4 text-center mx-auto"
            style={{ maxWidth: "520px" }}
          >
            <p className="mb-1">
              Your contribution has been successfully received.
            </p>
            <p className="mb-1">
              We sincerely appreciate your support and generosity.
            </p>
            <p className="mb-1">
              A donation receipt has been sent to the email address you
              provided. Please check your inbox (and spam folder, if needed).
            </p>
            <p className="mb-0">
              Thank you for helping us support and serve our community.
            </p>
          </div>
        )}

        {/* SHOW CONVERGE ID WHEN AVAILABLE */}
        {convergeId && (
          <div className="mb-3">
            <strong>Transaction ID:</strong>
            <div className="text-break mt-1">{convergeId}</div>
          </div>
        )}

        {token && screen !== "rsvp" && screen !== "purchase" && (
          <button onClick={onNavigate} className="btn btn-orange px-4 w-100 ">
            {isSuccess && buttonName === "event"
              ? "View Generated Tickets"
              : isSuccess
              ? "View Transactions"
              : "Try Again"}
          </button>
        )}
      </div>
    </div>
  );
};

export default PaymentStatusModal;
